// Maintain and distribute overarching organization filter data
(function () {
  'use strict';
  angular.module('obex').
  factory('myAgencyService', ['$q', '$window', 'organizations', 'authService',
    function ($q, $window, organizations, authService) {
      return {
        getAgency(orgId) {
          return organizations.getOrganizationById(orgId).then(function (response) {
            return response.data;
          });
        },
      };
    },
  ]);
})();



// WEBPACK FOOTER //
// ./client/js/services/myAgency.service.js